export const CRUSADER_UNIT_SIZE = 1168
